import {
  QuestionnaireResponseItemComponent,
  QuestionnaireResponseAnswerComponent,
  IQuestionnaireResponseItemBaseComponent,
} from '.';
import {
  isQuestionnaireResponseItemAnswer,
  isAttachmentAnswerComponent,
  isBooleanAnswerComponent,
  isCodingAnswerComponent,
  isDateAnswerComponent,
  isDateTimeAnswerComponent,
  isDecimalAnswerComponent,
  isQuantityAnswerComponent,
  isIntegerAnswerComponent,
  isStringAnswerComponent,
  isTimeAnswerComponent,
  isReferenceAnswerComponent,
  isUriAnswerComponent,
} from './typeGuards';
import { IReference } from '../Reference';
import { IQuantity } from '../Quantity';
import { IAttachment } from '../Attachment';
import { isCodingEqual } from '../Coding';
import { dateTime, date, time } from '../Primitives';

export const isAttachmentEqual = (a?: IAttachment, b?: IAttachment) => a === b;
export const isBooleanEqual = (a?: boolean, b?: boolean) => a === b;
export const isDateEqual = (a?: date, b?: date) => a === b;
export const isDateTimeEqual = (a?: dateTime, b?: dateTime) => a === b;
export const isDecimalEqual = (a?: number, b?: number) => a === b;
export const isQuantityEqual = (a?: IQuantity, b?: IQuantity) => a === b;
export const isIntegerEqual = (a?: number, b?: number) => a === b;
export const isStringEqual = (a?: string, b?: string) => a === b;
export const isTimeEqual = (a?: time, b?: time) => a === b;
export const isReferenceEqual = (a?: IReference, b?: IReference) => a === b;
export const isUriEqual = (a?: string, b?: string) => a === b;

export const isQuestionnaireResponseAnswerItemEqual = (
  a?: QuestionnaireResponseAnswerComponent | null,
  b?: QuestionnaireResponseAnswerComponent | null,
) => {
  if (!a || !b) return false;

  if (isAttachmentAnswerComponent(a) && isAttachmentAnswerComponent(b)) {
    return isAttachmentEqual(a.valueAttachment, b.valueAttachment);
  }
  if (isBooleanAnswerComponent(a) && isBooleanAnswerComponent(b)) {
    return isBooleanEqual(a.valueBoolean, b.valueBoolean);
  }
  if (isCodingAnswerComponent(a) && isCodingAnswerComponent(b)) {
    return isCodingEqual(a.valueCoding, b.valueCoding);
  }
  if (isDateAnswerComponent(a) && isDateAnswerComponent(b)) {
    return isDateEqual(a.valueDate, b.valueDate);
  }
  if (isDateTimeAnswerComponent(a) && isDateTimeAnswerComponent(b)) {
    return isDateTimeEqual(a.valueDateTime, b.valueDateTime);
  }
  if (isDecimalAnswerComponent(a) && isDecimalAnswerComponent(b)) {
    return isDecimalEqual(a.valueDecimal, b.valueDecimal);
  }
  if (isQuantityAnswerComponent(a) && isQuantityAnswerComponent(b)) {
    return isQuantityEqual(a.valueQuantity, b.valueQuantity);
  }
  if (isIntegerAnswerComponent(a) && isIntegerAnswerComponent(b)) {
    return isIntegerEqual(a.valueInteger, b.valueInteger);
  }
  if (isStringAnswerComponent(a) && isStringAnswerComponent(b)) {
    return isStringEqual(a.valueString, b.valueString);
  }
  if (isTimeAnswerComponent(a) && isTimeAnswerComponent(b)) {
    return isTimeEqual(a.valueTime, b.valueTime);
  }
  if (isReferenceAnswerComponent(a) && isReferenceAnswerComponent(b)) {
    return isReferenceEqual(a.valueReference, b.valueReference);
  }
  if (isUriAnswerComponent(a) && isUriAnswerComponent(b)) {
    return isUriEqual(a.valueUri, b.valueUri);
  }
  return false;
};

export const isQuestionnnaireResponseItemEqual = (
  a: IQuestionnaireResponseItemBaseComponent | null,
  b: IQuestionnaireResponseItemBaseComponent | null,
) => !!a && !!b && a.linkId === b.linkId;

export const isQuestionnnaireResponseItemDeepEqual = (
  a: QuestionnaireResponseItemComponent | null,
  b: QuestionnaireResponseItemComponent | null,
) => {
  const weakEqual = !!a && !!b && a.linkId === b.linkId;
  if (!weakEqual) return false;
  if (a && b) {
    if (
      isQuestionnaireResponseItemAnswer(a) &&
      isQuestionnaireResponseItemAnswer(b)
    ) {
      if (a.answer.length !== b.answer.length) return false;
      return a.answer.every(ans =>
        b.answer.some(bAns =>
          isQuestionnaireResponseAnswerItemEqual(ans, bAns),
        ),
      );
    }
    return true;
  }
  return false;
};
